import ExportHoverTooltip from './ExportHoverTooltip'
import {
  REPORT_DATA_SCOPE_LABELS,
  getOppositeDataScope,
  getWidgetScopeToggleTooltip,
} from './exportDataScope'
import './ExportDataScope.css'

export default function ExportWidgetDataScopeSwitch({
  chartLabel,
  value,
  reportDataScope,
  onChange,
}) {
  const isOverride = value !== reportDataScope
  const activeLabel =
    REPORT_DATA_SCOPE_LABELS[value] || REPORT_DATA_SCOPE_LABELS[reportDataScope]
  const tooltip = getWidgetScopeToggleTooltip({
    isOverride,
    reportDataScope,
  })

  const handleToggle = () => {
    onChange(isOverride ? reportDataScope : getOppositeDataScope(reportDataScope))
  }

  return (
    <div className="dashboardExportItemScope">
      <div className="dashboardExportItemScopeControl">
        <span className="dashboardExportScopeActiveLabel">{activeLabel}</span>
        <ExportHoverTooltip
          as="button"
          type="button"
          role="switch"
          content={tooltip}
          className="dashboardExportScopeSwitch"
          aria-checked={isOverride}
          aria-label={`${chartLabel} override report data scope: ${isOverride ? 'on' : 'off'}, ${activeLabel}`}
          onClick={handleToggle}
        >
          <span className="dashboardExportScopeSwitchTrack" aria-hidden="true">
            <span className="dashboardExportScopeSwitchThumb" />
          </span>
        </ExportHoverTooltip>
      </div>
    </div>
  )
}
